module.exports = __webpack_public_path__ + "static/img/soldout.2a208fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/bigPicModel/soldout.svg
// module id = hwXF
// module chunks = 1